import React, { FC } from 'react';

import { keyframes, Stack, styled, Typography } from '@mui/material';
import _ from 'lodash';

const Fade = keyframes({
  from: {
    opacity: 0,
  },
});

const FadingTypography = styled(Typography)<{ order: number }>(({ order }) => ({
  animation: `${Fade} 0.5s infinite alternate`,
  animationDelay: `${-order * 0.8}s`,
}));

export const LoadingText: FC<{
  symbol: string | string[];
  variant?: string;
  size?: number;
  repeatSymbol: number;
  spacing?: number;
}> = ({ symbol, repeatSymbol, variant, spacing = 0.25, size = 14 }) => {
  return (
    <Stack direction={'row'} spacing={spacing}>
      {[...Array(repeatSymbol)].map((_s, index) => (
        <FadingTypography fontSize={size} variant={(variant as any) ?? 'body2'} key={index} order={index + 1}>
          {_.isArray(symbol) ? (symbol.length - 1 > index ? symbol[index] : null) : symbol}
        </FadingTypography>
      ))}
    </Stack>
  );
};
